export default {
  topic: 'Fiscalité',
  titles: {
    currentSituation: 'Situation actuelle',
    kyc: 'Mise à jour de votre situation fiscale',
    contractSelection: "Montant à allouer à votre projet d'investissement",
    investmentConfiguration: 'Paramétrer votre opération',
    leversSelection: "Vos leviers d'actions",
    financialInvestment:
      'Investir dans les produits financiers avec un avantage fiscal',
    financialInvestmentSummary: 'Investissements financiers: récapitulatif',
    pivotAccountFunding: "Prélèvement à l'apport",
    realEstateInvestment:
      'Investir dans l’immobilier avec un cadre fiscal avantageux',
    synthesis: 'Synthèse des orientations retenues',
    report: "Rapport d'adéquation",
  },
}
